<script>
export default {
    name: 'IconVideo'
}
</script>
<template>
    <svg
        class="base-icon icon-video"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 8c13.255 0 24 10.745 24 24S45.255 56 32 56 8 45.255 8 32 18.745 8 32 8zm-7.2 14.4v19.2L44 32l-19.2-9.6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
